import moment from "moment";

export const findStatusFromNumericVal = (val) => {
    switch (val) {
        case 2:
            return "ACTIVE";
        case 3:
            return "INACTIVE";
        default:
            return "all";
    }
};
export const findPlanFromNumericVal = (val) => {
    switch (val) {
        case 2:
            return "free";
        case 3:
            return "premium";
        default:
            return "all";
    }
};

export const transformApiDataToForm = (apiData) => {
    if (!apiData) return {};

    const scheduleDate = apiData.scheduleAt
        ? moment.utc(apiData.scheduleAt).format("MMMM DD, YYYY")
        : "";

    const scheduleTime = apiData.scheduleAt
        ? moment.utc(apiData.scheduleAt).format("h:mm A")
        : "";

    return {
        id: apiData.id,
        title: apiData.title || "",
        message: apiData.message || "",
        scheduleDate: scheduleDate,
        scheduleTime: scheduleTime,
        status: apiData.status,
    };
};
